module.exports = __webpack_public_path__ + "media/images/aboveTheLineLogo-8e38174e.jpeg";